/* eslint-disable react/require-default-props */
import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import { useState } from 'react';
import Content from './Content';
import { NotationTag, PopoverIndicator } from './styled';

const { Modal } = Common;

interface NotationProps {
  symbol: string;
  notation: Array<any>;
  uma: boolean;
  name: string;
  isPopover?: boolean;
  isModal?: boolean;
  type?: string;
  isNotationBadges?: boolean;
  className?: string;
  placement?: string;
}

interface ITag {
  type?: string;
  isNotationBadges?: boolean;
  src?: string;
  alt?: string;
  className?: string;
}

const INDICATOR_ICON_URL = '/icon/ic_indicator.svg';
const UMA_ICON_URL = '/icon/ic_uma.svg';
const X_ICON_URL = '/icon/ic_x.svg';
const NOTATION_TYPE = {
  INDICATOR: 'indicator',
  UMA: 'uma',
  X: 'x',
};
const INDICATOR_ALT_TEXT = 'indikator notasi khusus';

function Notation({
  symbol,
  notation,
  uma,
  isModal,
  name,
  isPopover = true,
  type = NOTATION_TYPE.INDICATOR,
  isNotationBadges = false,
  className = '',
  placement = 'top',
}: NotationProps) {
  const [visible, setVisible] = useState<boolean>(false);

  const onCloseModal = () => setVisible(false);
  const isUma = type === NOTATION_TYPE.UMA && !!uma;
  const isX = type === NOTATION_TYPE.X;

  const renderTag = ({
    // eslint-disable-next-line no-shadow
    type = NOTATION_TYPE.INDICATOR,
    // eslint-disable-next-line no-shadow
    isNotationBadges = false,
    src = INDICATOR_ICON_URL,
    alt = INDICATOR_ALT_TEXT,
  }: ITag) => (
    <NotationTag type={type} isSmall isNotationBadges={isNotationBadges}>
      <Image alt={alt} src={src} />
    </NotationTag>
  );

  const renderNotation = () => {
    if (isUma) {
      return renderTag({
        type: NOTATION_TYPE.UMA,
        src: UMA_ICON_URL,
        alt: `${INDICATOR_ALT_TEXT} uma`,
        className: '',
        isNotationBadges,
      });
    }
    if (isX) {
      return renderTag({
        type: NOTATION_TYPE.X,
        src: X_ICON_URL,
        alt: `${INDICATOR_ALT_TEXT} x`,
        className: '',
        isNotationBadges,
      });
    }
    return renderTag({ type, isNotationBadges });
  };

  const renderContent = (isFullSize = false) => (
    <Content
      symbol={symbol}
      uma={uma}
      notation={notation}
      name={name}
      notationTag={renderTag({
        type: NOTATION_TYPE.INDICATOR,
        isNotationBadges: true,
      })}
      isFullSize={isFullSize}
    />
  );

  if (isModal) {
    return (
      <>
        <div onClick={() => setVisible(true)} aria-hidden="true">
          {renderTag({ type: NOTATION_TYPE.INDICATOR, isNotationBadges: true })}
        </div>
        <Modal
          visible={visible}
          onCancel={onCloseModal}
          title={null}
          centered
          width="500px"
        >
          {renderContent(true)}
        </Modal>
      </>
    );
  }

  if (!isPopover) {
    return renderNotation();
  }

  return (
    <PopoverIndicator
      className={className}
      content={renderContent()}
      placement={placement}
    >
      {renderNotation()}
    </PopoverIndicator>
  );
}

export default Notation;
